var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIRpe02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5575 6.36875C28.3916 4.36129 31.0799 3.05404 33.1998 4.73067C35.7597 6.75418 36.1966 11.8162 35.9332 15.1084C35.7372 17.5655 35.2683 19.8813 34.3368 22.1393C32.657 26.212 29.5222 29.3308 25.382 30.9111C20.4196 32.8094 14.8212 32.7676 9.9326 30.6766C4.55583 28.3737 1.48844 23.5815 0.428506 17.9542C-0.0597073 15.3622 -0.175339 12.799 0.316086 10.2166C0.630855 8.56892 1.1255 7.02398 2.0955 5.69746C3.18755 4.20391 4.9509 3.59686 6.7014 4.19427C9.30628 5.11289 11.1017 7.77879 12.4347 10.313C13.1863 8.46614 14.0664 6.75418 15.4539 5.34736C16.8896 3.89235 19.0448 3.75103 20.5769 5.10646C22.1379 6.39766 23.0758 8.36015 23.9366 10.3002C24.6593 8.84194 25.4751 7.54753 26.5543 6.36554L26.5575 6.36875Z",
    fill: "#4685EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0873 19.7239C25.038 21.4358 24.3924 24.1595 22.8603 24.3201C22.2886 24.3779 21.6623 24.0857 21.3218 23.4786C20.7084 22.393 20.7308 20.8159 21.3218 19.7206C21.6302 19.1489 22.1569 18.8823 22.658 18.8599C23.2201 18.8342 23.7597 19.1361 24.0873 19.7239Z",
    fill: "#231815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 19.6468C15.6888 21.2881 15.0946 24.1563 13.4758 24.3073C12.8687 24.3651 12.2649 23.9957 11.9405 23.3791C10.9737 21.545 11.7381 18.9691 13.1706 18.8599C13.7648 18.8149 14.3109 19.0622 14.6738 19.6468Z",
    fill: "#231815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.644 26.4658C20.644 26.4658 18.9192 26.7484 17.9075 27.6156C16.8989 26.7484 15.1709 26.4658 15.1709 26.4658",
    stroke: "#231815",
    strokeWidth: 1.28477,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRpe02);
export default __webpack_public_path__ + "static/media/i_RPE_02.d6be027c56d20511155af76917e9fadc.svg";
export { ForwardRef as ReactComponent };